import Colors from "../../../../global/Colors";

export const SwimLaneFilters = [
  {
    fieldName: "flag",
    title: "Case Flagged (AND)",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Flags",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: "core/dynamic-options/flags/",
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "law_firm",
    title: "Law Firms",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Law Firms",
    currentValue: [],
    checked: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: "core/dynamic-options/law-firms/",
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },
  {
    fieldName: "provider",
    title: "Provider",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Providers",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: "core/dynamic-options/providers/",
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  {
    fieldName: "created_at",
    title: "Date Created",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "due_date",
    title: "Due Date",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
];
